import type { ReduxState } from 'app/redux/types';

import { StakeType } from 'app/lib/staking/constants';
import { selectIsLoggedIn } from 'app/redux/selectors/auth';

import type { PreferencesState } from '../types/preferences';
import { insufficientFunds } from '../utils/action-button-state';
import {
  selectOneClickBetActive,
  selectToAllowPricePreference,
} from './preferences';
import { selectAmountStakeType, selectCurrentStakeType } from './stakeTypes';
import { selectSinglesAccumulateAmount } from './stakeTypes/single';
import { selectSystemResultingAmount } from './stakeTypes/system';

// ---

export type SubmissionPreferences = {
  oneClickBet: PreferencesState['oneClickBetActive'];
  acceptPriceChanges: PreferencesState['allowPricePreference'];
};

export const selectSubmissionPreferences = (state: ReduxState): SubmissionPreferences => ({
  oneClickBet: selectOneClickBetActive(state),
  acceptPriceChanges: selectToAllowPricePreference(state),
});

// ---

export const selectTotalAmount = (state: ReduxState): number => {
  let total = 0;
  const stakeType = selectCurrentStakeType(state);

  if (stakeType.has(StakeType.SINGLE)) {
    total = selectSinglesAccumulateAmount(state);
  }
  else if (stakeType.has(StakeType.EXPRESS)) {
    const amount = selectAmountStakeType(state).numeric;

    if (!Number.isNaN(amount)) {
      total = amount;
    }
  }
  else if (stakeType.has(StakeType.SYSTEM)) {
    const amount = selectSystemResultingAmount(state);

    if (amount !== null) {
      total = amount;
    }
  }

  return total;
};

export const selectHasEnoughMoney = (state: ReduxState): boolean => {
  if (!selectIsLoggedIn(state)) {
    // Пусть пользователь вводит любую сумму, пока он не авторизован
    return true;
  }

  const total = selectTotalAmount(state);

  return !insufficientFunds(state, total);
};
